import React, { useState, useEffect } from "react";
import {
  Typography,
  Drawer,
  Box,
  List,
  ListItem,
  ListItemText,
  IconButton,
  CardHeader,
  Tooltip,
  Icon,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/styles";
import Fade from "@material-ui/core/Fade";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { remote_service_client_info } from "./../utils";
import DIlogo from "./../assets/dil_logo_white.png";
import infoIcon from "./../assets/infoIcon.svg";
import content from "./../assets/content.json";
import { assets } from "./../assets/assets";


const useStyles = makeStyles((theme) => ({
  avatar: {
    height: "24px !important",
    width: "24px !important",
  },
  wideAvatar: {
    height: "24px !important",
    width: "48px !important",
  },
}));

const welcomeTextStyle = {
  color: "#FFC627",
  textAlign: "center",
  px: 2,
  m: 2,
  fontSize: "14px",
  pb: 0,
};

const commandsStyle = {
  color: "#c2c4c3",
  fontSize: 14,
  pl: 3,
};

const sectionHeaderStyle = {
  color: "#FFC627",
};

const listItemStyle = {
  // bgcolor: "#101F33",
  py: 0.5,
  pl: 3,
};

const cardHeaderStyle = {
  pt: 1,
  pb: 0,
  pl: 2,
};
const drawerWidth = 300;

export default function Navigator({
  open,
  title,
  handleDrawerClose,
  preferredname,
  firstname,
  lastname,
  sessionid,
  expiryMil,
  payload,
  usersessionid,
  sdkid,
  handleEndofSession,
  handleInstructionOpen,
  language,
}) {
  const [openCommands, setOpenCommands] = useState(true);
  const [openTools, setOpenTools] = useState(false);
  const [openSessionInfo, setOpenSessionInfo] = useState(false);
  const [sessionstatus, setSessionstatus] = useState("Loading...");
  const currentLanguage = content[language]["content"]
  const currentAssets = assets[language];


  const handleClickCommands = () => {
    setOpenCommands(!openCommands);
  };

  const handleClickTools = () => {
    setOpenTools(!openTools);
  };

  const handleClickInfo = () => {
    setOpenSessionInfo(!openSessionInfo);
  };

  const list = {
    id: "user_payload",
    children: [
      { id: "Dreamscape Session: " + sessionid, icon: null },
      // { id: "Furioos Session: " + sdkid, icon: null },
      { id: currentLanguage["status"] + ": " + sessionstatus },
      { id: currentLanguage["first_name"] + ": " + firstname, icon: null },
      { id: currentLanguage["last_name"] + ": " + lastname, icon: null },
    ],
  };

  const classes = useStyles();
  const [time, setTime] = useState();
  const msToHour = (duration) => {
    var hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    return hours < 10 && hours > 0 ? "0" + hours : hours;
  };

  const msToMin = (duration) => {
    var minutes = Math.floor((duration / (1000 * 60)) % 60);
    return minutes < 10 && minutes > 0 ? "0" + minutes : minutes;
  };

  const msToSec = (duration) => {
    var seconds = Math.floor((duration / 1000) % 60);
    return seconds < 10 && seconds > 0 ? "0" + seconds : seconds;
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerHeight < 600) {
        setOpenTools(false);
        setOpenCommands(false);
        setOpenSessionInfo(false);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();

    if (expiryMil) {
      setTime(expiryMil);
      const interval = setInterval(() => {
        setTime((time) => time - 1000);
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
        window.removeEventListener("resize", handleResize);
      }, expiryMil);

      const statusInterval = setInterval(() => {
        remote_service_client_info(payload, usersessionid)
          .then((res) => {
            setSessionstatus(res.data.manifest.session_status_description);
            if (
              res.data.manifest.session_status_code === 1200 ||
              res.data.manifest.session_status_code === 1251
            ) {
              clearInterval(statusInterval);
              if (res.data.manifest.session_status_code === 1200) {
                handleEndofSession();
              }
            }
          })
          .catch((error) => {
            console.error(error.response);
            console.error(
              "Failed to update status at " + new Date() + ", trying again..."
            );
          });
      }, 5000);
    }

    return () => window.removeEventListener("resize", handleResize);
  }, [expiryMil, payload, usersessionid]);

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <img src={DIlogo} alt={currentLanguage["alt-DS_logo"]} height={"190px"} />
      <Box sx={{ ...commandsStyle, ...sectionHeaderStyle, mb: 1 }}>
        <Typography sx={{ fontSize: "26px" }}>
          <strong>{title.split("Act")[0]}</strong>
        </Typography>
        <Typography sx={{ fontSize: "26px" }}>
          Act {title.split("Act")[1]}
        </Typography>
      </Box>

      <Box sx={{ ...commandsStyle, mb: 1 }}>
        <Typography sx={{ ...sectionHeaderStyle, display: "inline" }}>
          <strong>{currentLanguage["keyboard_ccntrols"]}</strong>
        </Typography>
        <Box
          component="span"
          sx={{ verticalAlign: "middle", pr: 2, float: "right" }}
          onClick={handleClickCommands}
        >
          {openCommands ? (
            <IconButton
              sx={{
                "&:hover": {
                  backgroundColor: "#FFC627",
                  color: "#000",
                  cursor: "pointer",
                },
                p: "4px",
                backgroundColor: "rgba(255, 198, 39, 0.2)",
                color: "#FFC627",
              }}
              aria-label={currentLanguage["aria-labels_keyboard_controls_close"]}
            >
              <RemoveIcon sx={{ m: 0, fontSize: "16px" }} />
            </IconButton>
          ) : (
            <IconButton
              sx={{
                "&:hover": {
                  backgroundColor: "#FFC627",
                  color: "#000",
                  cursor: "pointer",
                },
                p: "4px",
                backgroundColor: "rgba(255, 198, 39, 0.2)",
                color: "#FFC627",
              }}
              aria-label={currentLanguage["aria-labels_keyboard_controls"]}
            >
              <AddIcon sx={{ m: 0, fontSize: "16px" }} />
            </IconButton>
          )}
        </Box>
        <Box
          component="span"
          sx={{ verticalAlign: "middle", pr: 3, float: "right" }}
          onClick={handleInstructionOpen}
        >
          <IconButton
            sx={{
              "&:hover": {
                backgroundColor: "#FFC627",
                color: "#000",
                cursor: "pointer",
              },
              p: 0,
              backgroundColor: "rgba(255, 198, 39, 0.2)",
              color: "#FFC627",
            }}
            aria-label={currentLanguage["aria-labels_toggle"]}
          >
            <Icon
              sx={{
                width: "0.6em",
                height: "0.6em",
                display: "flex",
              }}
            >
              <img src={infoIcon} height={"100%"} />
            </Icon>
          </IconButton>
        </Box>

        <Fade in={openCommands} unmountOnExit>
          <React.Fragment>
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-forward"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-forward"]}
                    className={classes.avatar}
                    variant="rounded"
                    src={currentAssets.forwardIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["move_forward"]}
            />
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-backward"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-backward"]}
                    className={classes.avatar}
                    variant="rounded"
                    src={currentAssets.backIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["move_back"]}
            />
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-left"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-left"]}
                    className={classes.avatar}
                    variant="rounded"
                    src={currentAssets.leftIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["move_left"]}
            />
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-right"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-right"]}
                    className={classes.avatar}
                    variant="rounded"
                    src={currentAssets.rightIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["move_right"]}
            />
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-cc"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-cc"]}
                    className={classes.avatar}
                    variant="rounded"
                    src={currentAssets.captionIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["closed_caption"]}
            />
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-pause"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-pause"]}
                    style={{ width: "78px", height: "24px" }}
                    variant="rounded"
                    src={currentAssets.upIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["pause"]}
            />
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-action"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-action"]}
                    className={classes.wideAvatar}
                    variant="rounded"
                    src={currentAssets.enterIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["initiate_action"]}
            />
          </React.Fragment>
        </Fade>
      </Box>

      <Box sx={{ ...commandsStyle, mb: 1 }}>
        <Typography sx={{ ...sectionHeaderStyle, display: "inline" }}>
          <strong>{currentLanguage["mouse_controls"]}</strong>
        </Typography>

        <Box
          component="span"
          sx={{ verticalAlign: "middle", pr: 2, float: "right" }}
          onClick={handleClickTools}
        >
          {openTools ? (
            <IconButton
              sx={{
                "&:hover": {
                  backgroundColor: "#FFC627",
                  color: "#000",
                  cursor: "pointer",
                },
                p: "4px",
                backgroundColor: "rgba(255, 198, 39, 0.2)",
                color: "#FFC627",
              }}
              aria-label={currentLanguage["aria-labels_mouse_controls_close"]}
            >
              <RemoveIcon sx={{ m: 0, fontSize: "16px" }} />
            </IconButton>
          ) : (
            <IconButton
              sx={{
                "&:hover": {
                  backgroundColor: "#FFC627",
                  color: "#000",
                  cursor: "pointer",
                },
                p: "4px",
                backgroundColor: "rgba(255, 198, 39, 0.2)",
                color: "#FFC627",
              }}
              aria-label={currentLanguage["aria-labels_mouse_controls"]}
            >
              <AddIcon sx={{ m: 0, fontSize: "16px" }} />
            </IconButton>
          )}
        </Box>

        <Box
          component="span"
          sx={{ verticalAlign: "middle", pr: 3, float: "right" }}
          onClick={handleInstructionOpen}
        >
          <IconButton
            sx={{
              "&:hover": {
                backgroundColor: "#FFC627",
                color: "#000",
                cursor: "pointer",
              },
              p: 0,
              backgroundColor: "rgba(255, 198, 39, 0.2)",
              color: "#FFC627",
            }}
            aria-label={currentLanguage["aria-labels_toggle"]}
          >
            <Icon
              sx={{
                width: "0.6em",
                height: "0.6em",
                display: "flex",
              }}
            >
              <img src={infoIcon} height={"100%"} />
            </Icon>
          </IconButton>
        </Box>
        <Fade in={openTools} unmountOnExit>
          <React.Fragment>
            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-select_or_scan"]}
                  followCursor
                  placement="bottom-end"
                  enterDelay={500}
                  leaveDelay={0}
                >
                  <Avatar
                    alt={currentLanguage["alt-select_or_scan"]}
                    variant="rounded"
                    src={currentAssets.leftMouse}
                    style={{ width: "100%", height: "100%" }}
                  />
                </Tooltip>
              }
              title={currentLanguage["point_scan"]}
            />

            <CardHeader
              sx={{ ...cardHeaderStyle }}
              avatar={
                <Tooltip
                  title={currentLanguage["alt-click"]}
                  followCursor
                  placement="bottom-end"
                >
                  <Avatar
                    alt={currentLanguage["alt-click"]}
                    className={classes.wideAvatar}
                    variant="rounded"
                    src={currentAssets.buttonIcon}
                  />
                </Tooltip>
              }
              title={currentLanguage["button"]}
            />
          </React.Fragment>
        </Fade>
      </Box>

      <Box sx={{ ...commandsStyle }}>
        <Typography sx={{ ...sectionHeaderStyle, display: "inline" }}>
          <strong>{currentLanguage["session_information"]}</strong>
        </Typography>
        <Box
          component="span"
          sx={{ verticalAlign: "middle", pr: 2, float: "right" }}
          onClick={handleClickInfo}
        >
          {openSessionInfo ? (
            <IconButton
              sx={{
                "&:hover": {
                  backgroundColor: "#FFC627",
                  color: "#000",
                  cursor: "pointer",
                },
                p: "4px",
                backgroundColor: "rgba(255, 198, 39, 0.2)",
                color: "#FFC627",
              }}
              aria-label={currentLanguage["aria-labels_session_info_close"]}
            >
              <RemoveIcon sx={{ m: 0, fontSize: "16px" }} />
            </IconButton>
          ) : (
            <IconButton
              sx={{
                "&:hover": {
                  backgroundColor: "#FFC627",
                  color: "#000",
                  cursor: "pointer",
                },
                p: "4px",
                backgroundColor: "rgba(255, 198, 39, 0.2)",
                color: "#FFC627",
              }}
              aria-label={currentLanguage["aria-labels_session_info"]}

            >
              <AddIcon sx={{ m: 0, fontSize: "16px" }} />
            </IconButton>
          )}
        </Box>
      </Box>

      <Fade in={openSessionInfo} unmountOnExit>
        <List sx={{ pt: 0 }}>
          {list.children.map((item) => (
            <React.Fragment key={item.id}>
              <ListItem sx={{ ...listItemStyle }}>
                <ListItemText sx={{ color: "#c2c4c3", m: 0, px: 2 }}>
                  {item.id}
                </ListItemText>
              </ListItem>
              {/* <Divider light /> */}
            </React.Fragment>
          ))}

          <ListItem sx={{ ...listItemStyle }}>
            <ListItemText sx={{ color: "#c2c4c3", m: 0, px: 2 }}>
              <React.Fragment>
                Expiry:{" "}
                {time > 0 && (
                  <Box component="span" sx={{ color: "#FFC627" }}>
                    {msToHour(time)}:{msToMin(time)}:{msToSec(time)}
                  </Box>
                )}
                {!(time > 0) && (
                  <Box component="span" sx={{ color: "#FFC627" }}>
                    {"Expired"}
                  </Box>
                )}
              </React.Fragment>
            </ListItemText>
          </ListItem>
          <ListItem sx={{ ...listItemStyle }}>
            <ListItemText sx={{ color: "#c2c4c3", m: 0, px: 2 }}>
              {currentLanguage["version"]}: v1.0.2
            </ListItemText>
          </ListItem>
        </List>
      </Fade>
      <IconButton
        onClick={handleDrawerClose}
        sx={{
          "&:hover": {
            backgroundColor: "#FFC627",
            color: "#000",
            cursor: "pointer",
          },
          width: "40px",
          padding: "8px",
          bottom: "10px",
          position: "fixed",
          left: "245px",
          backgroundColor: "rgba(255, 198, 39, 0.2)",
          color: "#FFC627",
        }}
        aria-label={currentLanguage["aria-labels_slide_bar"]}
      >
        <ChevronLeftIcon />
      </IconButton>
    </Drawer>
  );
}
